import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./CollabsView.module.css"
import { Column } from "primereact/column";
import Langs, { Localize } from "../../app/lang/langs";
import { getEmploymentPromises } from "../../components/employmentPromises/employmentPromisesSlice";
import { Tag } from "primereact/tag";
import { FilterMatchMode } from "primereact/api";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import moment from "moment";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import EmploymentPromisesAddModal from "./EmploymentPromisesAddModal";
import EmploymentPromisesEditModal from "./EmploymentPromisesEditModal";
import addIcon from "../../assets/images/add.png";
import addIconFocus from "../../assets/images/addFocus.png";
import { Col, Row } from "react-bootstrap";
import ImageButton from "../../components/buttons/ImageButton";

export default function EmploymentPromisesView() {

    const dispatch = useDispatch();
    const mounted = useRef();

    const list = useSelector((state) => state.employmentPromises.list);
    const isMobile = useSelector((state) => state.settings.isMobile);

    const [globalFilterValue, setGlobalFilterValue] = useState('');



    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        family_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        company_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        email: { value: null, matchMode: FilterMatchMode.CONTAINS },
        progression: { value: null, matchMode: FilterMatchMode.EQUALS },
        status: { value: null, matchMode: FilterMatchMode.EQUALS },
        request_date: { value: null, matchMode: FilterMatchMode.DATE_IS },
        start_date: { value: null, matchMode: FilterMatchMode.DATE_IS },
        sent_date: { value: null, matchMode: FilterMatchMode.DATE_IS }
    });
    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const [onViewPromise, setOnViewPromise] = useState(null);
    const [onViewVisibile, setOnViewVisible] = useState(false);

    const [onAddViewVisible, setOnAddViewVisible] = useState(false);

    useEffect(() => {
        if (!mounted.current) {
            mounted.current = true;
            dispatch(getEmploymentPromises());
        }
    });

    const statusBodyTemplate = (rowData) => {
        return (
            <span className={`badge ${rowData.status === "OK" ? "bg-success" : "bg-danger"}`}>
                {rowData.status}
            </span>
        );
    }
    const progressionBodyTemplate = (rowData) => {
        const status = rowData.progression;
        let severity;
        switch (status) {
            case "Attente d'envoi":
                severity = 'warning';
                break;
            case 'Envoyé':
                severity = 'info';
                break;
            case 'Reçu':
                severity = 'success';
                break;
            default:
                severity = null;
        }
        return <Tag value={status} severity={severity} />;
    };
    const tableHeader = () => {
        return (
            <Row>
                <Col lg={6}>
                    <IconField iconPosition="left">
                        <InputIcon className="pi pi-search" />
                        <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                    </IconField>
                </Col>
                <Col md={6} className="d-flex justify-content-end">
                    <ImageButton
                        image={addIcon}
                        imageFocus={addIconFocus}
                        onClick={() => {
                            setOnAddViewVisible(true);
                        }}
                        active={true}
                        width={32}
                    />
                </Col>
            </Row>
        );
    };
    const getFormattedDate = (date) => {
        if (!date) return null;
        return moment(date).format("DD/MM/YYYY");
    }
    const dateBodyTemplate = (rowData, column) => {
        return getFormattedDate(rowData[column.field]);
    }

    const progressionRowFilterTemplate = (options) => {
        return (
            <Dropdown value={options.value}
                options={["Attente d'envoi", 'Envoyé', 'Reçu']}
                onChange={(e) => options.filterApplyCallback(e.value)}
                placeholder={<Langs str={"Select"} />}
                className="p-column-filter"
                showClear
                style={{ minWidth: '12rem' }}
            />
        )
    }
    const statusRowFilterTemplate = (options) => {
        return (
            <Dropdown value={options.value}
                options={['OK', 'KO']}
                onChange={(e) => options.filterApplyCallback(e.value)}
                placeholder={<Langs str={"Select"} />}
                className="p-column-filter"
                showClear
                style={{ minWidth: '12rem' }}
            />
        )
    }

    const dateFilterTemplate = (options) => {
        return <Calendar value={options.value}
            onChange={(e) => { options.filterCallback(e.value, options.index) }}
            dateFormat="dd/mm/yy"
            placeholder="dd/mm/yyyy"
            mask="99/99/9999" />
    }
    const onRowDoubleClick = (e) => {
        setOnViewVisible(true)
        setOnViewPromise(e.data)
    }
    const body = () => {
        let scrollHeight = "calc(100vh - 280px)"
        switch (isMobile) {
            case 2:
                scrollHeight = "calc(100vh - 340px)"
                break;
            case 3:
                scrollHeight = "calc(100vh - 270px)"
                break;
            default:
                break;
        }
        return (
            <div className={styles.collabsCard}>
                <DataTable
                    value={list}
                    dataKey="id"
                    paginator
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    rowsPerPageOptions={[10, 25, 50]}
                    rows={25}
                    scrollable
                    scrollHeight={scrollHeight}
                    sortMode="single"
                    selectionMode="single"
                    filters={filters}
                    currentPageReportTemplate={`{first} ${Localize("to")} {last} ${Localize("of")} {totalRecords}`}
                    header={tableHeader}
                    onRowDoubleClick={onRowDoubleClick}
                >
                    <Column field="id" header={Localize("ID")} sortable dataType="text" style={{ minWidth: '8rem' }} />
                    <Column field="company_name" header={Localize("Company")} sortable dataType="text" style={{ minWidth: '8rem' }} />
                    <Column field="family_name" header={Localize("Family Name")} filter sortable dataType="text" style={{ minWidth: '8rem' }} />
                    <Column field="name" header={Localize("Name")} dataType="text" filter sortable style={{ minWidth: '9rem' }} />
                    <Column field="email" header={Localize("EMAIL")} dataType="text" filter sortable style={{ minWidth: '9rem' }} />
                    <Column field="progression" showFilterMatchModes={false} filterElement={progressionRowFilterTemplate} body={progressionBodyTemplate} header={Localize("Progression")} dataType="text" filter sortable style={{ minWidth: '9rem' }} />
                    <Column field="status" showFilterMatchModes={false} filterElement={statusRowFilterTemplate} body={statusBodyTemplate} header={Localize("STATUS")} dataType="text" filter sortable style={{ minWidth: '9rem' }} />
                    <Column field="request_date" body={dateBodyTemplate} filterElement={dateFilterTemplate} header={Localize("REQUEST_DATE")} dataType="date" filter sortable style={{ minWidth: '9rem' }} />
                    <Column field="sent_date" body={dateBodyTemplate} filterElement={dateFilterTemplate} header={Localize("SENT_DATE")} dataType="date" filter sortable style={{ minWidth: '9rem' }} />
                    <Column field="start_date" body={dateBodyTemplate} filterElement={dateFilterTemplate} header={Localize("START_DATE")} dataType="date" filter sortable style={{ minWidth: '9rem' }} />
                </DataTable>
                <EmploymentPromisesAddModal
                    visible={onAddViewVisible}
                    setVisible={setOnAddViewVisible} />

                <EmploymentPromisesEditModal
                    visible={onViewVisibile}
                    setVisible={setOnViewVisible}
                    onViewItem={onViewPromise}
                    setOnViewItem={setOnViewPromise}
                />
            </div>
        )
    }

    return (
        body()
        // <div className="d-flex flex-column align-items-center justify-content-center card" style={{ height: "100vh" }}>
        //     <h1>Coming Soon</h1>
        //     <p>This feature is under development.</p>
        // </div>
    );
}